import React, { useState, useMemo } from "react";
import { FloatButton, Badge, Button } from "antd";
import { MessageOutlined, CloseOutlined } from "@ant-design/icons";
import ChatList from "./ChatList";
import ChatWindow from "./ChatWindow";
import { mockChats as initialChats } from "./mockData";
import "./Chat.css";

// Som de notificação embutido em Base64 para garantir a reprodução
const notificationSoundData =
  "data:audio/mpeg;base64,/+MYxAAEaAIEeUAQAgBgNgP/////KQQ/////Lvrg+lcWYHgtjadzsbTq+yREu495tq9c6v/7vt/of7mna9v6/btUnU17Jun9/+MYxCkT26KW+YGBAj9v6vUh+zab//v/96C3/pu6H+pv//r/ycIIP4pcWWTRBBBAMXgNdbRaABQAAABRWKwgjQVX0ECmrb///+MYxBQSM0sWWYI4A++Z/////////////0rOZ3MP//7H44QEgxgdvRVMXHZseL//540B4JAvMPEgaA4/0nHjxLhRgAoAYAgA/+MYxAYIAAJfGYEQAMAJAIAQMAwX936/q/tWtv/2f/+v//6v/+7qTEFNRTMuOTkuNVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";

const Chat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [showClosed, setShowClosed] = useState(false);
  const [chats, setChats] = useState(initialChats);

  const unreadTotal = useMemo(
    () => chats.reduce((total, chat) => total + (chat.unreadCount || 0), 0),
    [chats]
  );

  const toggleChat = () => {
    const nextIsOpen = !isOpen;
    setIsOpen(nextIsOpen);

    if (nextIsOpen && unreadTotal > 0) {
      const updatedChats = chats.map((c) => ({ ...c, unreadCount: 0 }));
      setChats(updatedChats);
    }

    if (!nextIsOpen) {
      setSelectedChat(null);
    }
  };

  const handleSelectChat = (chat) => {
    setSelectedChat(chat);
  };

  const handleBackToList = () => {
    setSelectedChat(null);
  };

  const toggleShowClosed = () => {
    setShowClosed(!showClosed);
  };

  const visibleChats = chats.filter((chat) =>
    showClosed ? chat.status === "closed" : chat.status === "open"
  );

  const chatIcon = <MessageOutlined />;

  return (
    <>
      {/*
      <FloatButton
        className="chat-float-button-xl"
        icon={isOpen ? <CloseOutlined /> : chatIcon}
        type="primary"
        onClick={toggleChat}
      />

      {isOpen && (
        <div className="chat-container">
          {selectedChat ? (
            <ChatWindow chat={selectedChat} onBack={handleBackToList} />
          ) : (
            <ChatList 
              chats={visibleChats} 
              onSelectChat={handleSelectChat} 
              onToggleShowClosed={toggleShowClosed}
              showClosed={showClosed}
            />
          )}
        </div>
      )} */}
    </>
  );
};

export default Chat;
